import React from "react";
import companyLogoSmall from "../../assets/Kmodo_logo_letter_cropped.png";

export const KmodoLogoSmall = () => {
  return <img alt="small-company-logo" src={companyLogoSmall} width="40px" />;
};
